define(function(require,exports,module) {
    var tpl =
            '<div class="like">'+
                '<div class="head">猜你喜欢</div>'+
                '<div class="items frame" id="frame">'+
                    '<ul id="hScroll" data-items="<%=data.length%>" class="slidee">'+
                        '<% for(var i=0; i<data.length; i++) { %>'+
                            '<li skuid="J_<%= data[i].sku %>">'+ 
                                '<a href="//item.jd.hk/<%=data[i].sku%>.html" target="_blank">'+
                                    '<img data-original="//img13.360buyimg.com/cms/<%= data[i].img %>' + '" src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" class="itemImg lazy">'+
                                    '<span class="name"><%= data[i].t %></span>' +
                                    '<span class="price">' +
                                        '<span></span>' +
                                    '</span>' +
                                '</a>' +
                            '</li>' +
                        '<% } %>' +
                    '</ul>' +
                '</div>' +
                '<% if(data.length > 4) { %>' +
                    '<div class="control">' +
                        '<div class="prev" id="prev">' +
                            '<i></i>' +
                        '</div>' +
                        '<div class="scrollbar" id="scrollbar">' +
                            '<div class="handle">' +
                                '<div class="mousearea"></div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="next" id="next">' +
                            '<i></i>' +
                        '</div>' +
                        '<span class="clr"></span>' +
                    '</div>' +
                '<% } %>' +
            '</div>';
    exports.tpl = tpl;
});


// WEBPACK FOOTER //
// ./src/js/template/indexV2RecmdRight.js